module.exports = __webpack_public_path__ + "static/media/p13.9b843db7.jpeg";